import React from "react";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import QueueProGate from "../../components/QueueProGate";
import QueuedOrders from "../../components/QueuedOrders";
import { managerAxios } from "../../axiosInstance";
import useDefaultCurrency from "../../utility/useDefaultCurrency";

function QueuedOrdersPage() {
  const { data } = useDefaultCurrency("manager");
  return (
    <div className="lg:overflow-y-hidden">
      {/* Header */}
      <div className="flex justify-between mb-4 items-center">
        <h3 className="text-xl font-semibold flex items-center gap-1">
          <PendingActionsIcon />
          Queue
        </h3>
      </div>
      <QueueProGate api={managerAxios} role="manager">
        <QueuedOrders
          api={managerAxios}
          role="manager"
          currency={data?.currency?.symbol}
        />
      </QueueProGate>
    </div>
  );
}

export default QueuedOrdersPage;
